import instance from '@apis/instance';
import { IdentifyRequest, IdentifyResponse } from '@models/identify';

class IdentifyApi {
  static identify(request: IdentifyRequest): Promise<IdentifyResponse> {
    return instance.post('/identity/verification/nice', request);
  }
}

export default IdentifyApi;
